var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card",
      attrs: {
        "data-bot": _vm.isCustomizable
          ? "dashboard__card--is-customizable"
          : false
      }
    },
    [
      _vm.showHeader
        ? _c(
            "header",
            {
              staticClass: "card-header",
              class: { "header-corp": _vm.type == "corp" }
            },
            [
              _c(
                "div",
                { staticClass: "typographies-heading-h3" },
                [_vm._t("title")],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "card-actions" },
                [
                  _vm._t("actions"),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "dinlineb" },
                    [
                      _c(
                        "CompassMenu",
                        {
                          ref: "refMenuActions",
                          attrs: {
                            trigger: "hover",
                            placement: "bottom-end",
                            customClass: "layout-card__dropdown"
                          }
                        },
                        [
                          _c("CompassIconButton", {
                            staticClass: "layout-card__dropdown-icon",
                            attrs: { icon: "action" }
                          }),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "dropdown" },
                            [
                              _vm.canRefresh
                                ? _c("CompassMenuItem", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.actions.refresh"
                                      ),
                                      "data-bot":
                                        "dashboard__card-menu--refresh"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("refresh-card")
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isCustomizable
                                ? _c("CompassMenuItem", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.actions.configure"
                                      ),
                                      "data-bot": "dashboard__card-menu--edit"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("edit-card")
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("CompassMenuItem", {
                                attrs: {
                                  label: _vm.$t.__("common.labels.hide"),
                                  "data-bot": "dashboard__card-menu--hide"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("hide-card")
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body prelative" },
        [
          _vm.loading === true
            ? _c(
                "div",
                { staticClass: "card-loader pabsolute" },
                [_c("preloader", { attrs: { display: true } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.error
            ? _vm._t("content", [
                _c(
                  "div",
                  {
                    staticClass:
                      "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                    staticStyle: { width: "170px" }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.placeholderImg, alt: "", width: "120" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3 gray-60 acenter" }, [
                      _vm._v(_vm._s(_vm.placeholderText))
                    ])
                  ]
                )
              ])
            : _c("div", { staticClass: "acenter" }, [
                _c("div", {
                  staticClass: "alert alert-danger",
                  domProps: { innerHTML: _vm._s(_vm.error) }
                })
              ])
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer" }, [_vm._t("footer")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }